import type { PathValue } from 'viewup-lib/types';

export type GetNestedValue = <T, P extends string>(obj: T, path: P) => PathValue<T, P>;
export const getNestedValue: GetNestedValue = (obj, path) => {
  return path.split('.').reduce((value, key) => value && (value as any)[key], obj) as any;
};
